import { userData } from "util/userData";
import { HttpRequest } from "util/http";
import * as React from "react";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from "components/ui/FontAwesomeIcon";
import {id} from "aws-sdk/clients/datapipeline";

interface dropdownProps {
  userList: User[]
  selectedUser: number
  domainWhitelist: string[]
  id?: string
  saveNewUser?: boolean
  onChange: (userId: number, newUser: boolean, newUserEmail?: string) => void
}

interface dropdownState {
  isOpen: boolean
  inputUser: string
  inputUserValidation: boolean
  inputUserWarningText: string
  isNewUser: boolean
  userList: User[]
  filteredList: User[]
  selectedUser: number
  domainWhitelist: string[]
  adminEmails: User[]
}

export class SelectUserDropdown extends React.Component<dropdownProps, dropdownState>{
  _isMounted = false;
  state = {
    isOpen: false,
    inputUser: '',
    inputUserValidation: true,
    inputUserWarningText: '',
    isNewUser: false,
    userList: this.props.userList,
    filteredList: this.props.userList,
    selectedUser: this.props.selectedUser,
    domainWhitelist: [],
    adminEmails: [],
  }
  constructor(props) {
    super(props);
    this.getDomains();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.filterUserList = this.filterUserList.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.state.isOpen !== prevState.isOpen) {
      if (this._isMounted) {
        this.setState({
          inputUser: '',
          inputUserValidation: true,
          inputUserWarningText: '',
          filteredList: this.props.userList
        });
      }
    }
    if (prevProps.userList != this.props.userList)
      if (this._isMounted) {
        this.setState({userList: this.props.userList});
      }
    if (prevProps.selectedUser != this.props.selectedUser)
      if (this._isMounted) {
        this.setState({selectedUser: this.props.selectedUser});
      }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  toggle() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let partialState = {};
    partialState[name] = value;

    this.setState(partialState, () => this.filterUserList(value));
  }

  getDomains() {
    const data = { current_project: userData.getCurrentProject() };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_domains', { data, method })
      .then((res: any) => {
        if (res) {
          let domains = [];
          res.forEach((object) => {
            domains.push(object.domain);
          });
          if (this._isMounted) {
            this.setState({domainWhitelist: domains});
          }
        }
      });
  }

  /**
   * Check if user belongs to one of the domains within the domains white list
   * @param username email valid adress
   * @param domainWhitelist List of white-listed domains
   */
  validateUser = (username: string, domainWhitelist: string[]) => {
    let validation: IValidationResponse = {
      isValid: false,
      inputFeedback: 'Invalid user.'
    }
    return new Promise((resolve => {
      const emailCheckRE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      const usernameDomain = username.split('@')[1];

      if (domainWhitelist.includes(usernameDomain) && emailCheckRE.test(username)) {
        const data = {username: username, current_project: userData.getCurrentProject()};
        const method = 'POST';
        HttpRequest.fetch('/scripts/alert_form/verifyUsername', {data, method})
            .then((res: any) => {
              if (res.count == 0) {
                validation = {
                  isValid: true,
                  inputFeedback: ''
                }
              } else {
                validation = {
                  isValid: false,
                  inputFeedback: 'Warning: The user you attempted to create already exists. Please select from the menu above.'
                }
              }
              resolve(validation);
            })
            .catch(() => {
              validation = {
                isValid: false,
                inputFeedback: 'Could not validate user on the server'
              }
              resolve(validation);
            })
      } else {
        if (!emailCheckRE.test(username)) {
          resolve(validation)
          return;
        }

        if (!domainWhitelist.includes(usernameDomain))
          validation.inputFeedback = `The Alerts Only User you are attempting to create does not have an approved email domain. Only email addresses from the following URLS are allowed: ${domainWhitelist.join(', ')} .`;
        resolve(validation);
      }
    }))
  }

  /**
   * Tries to save new user in DB. Returns new user ID on success or false otherwise
   * @param username email valid address
   * @returns {(number|boolean)}
   */
  addTempUser(username: string) {
    const validUserName = username.split('@')[0]
    const method = 'POST';
    const data = {
      user: username,
      username: username,
      p: '',
      email: username
    }

    return Date.now();
  }

  /**
   * Tries to save new user in DB. Returns new user ID on success or false otherwise
   * @param username email valid address
   * @returns {(number|boolean)}
   */
  addUser(username: string) {
    const validUserName = username.split('@')[0]
    const method = 'POST';
    const data = {
      user: username,
      username: username,
      p: '',
      email: username
    }

    return HttpRequest.fetch('scripts/admin_action_alerts/user/createAlertOnly', { data, method }).then((res: any) => {
      if (res && res.id) {
        // Send notification to admins

      }
      return res;
    })
  }

  /**
   * Add new user to dropdown list and set inputUser to new ID
   * @param id New Created User ID
   */
  selectUser(id: any) {
    if (Number.isInteger(id)) {
      const { onChange } = this.props;
      const newUser: User = {
        id: id,
        email: this.state.inputUser,
        username: this.state.inputUser
      }
      let { userList } = this.state;
      userList.push(newUser);
      this.setState({ userList: userList }, () => {
        onChange(id, true, newUser.email);
        this.toggle();
      });
    }
    return false;
  }

  /**
   * Add new user
   */
  newUser() {
    const { inputUser } = this.state;
    const { domainWhitelist } = this.state;
    this.validateUser(inputUser, domainWhitelist)
        .then((validation: IValidationResponse) => {
          if (validation.isValid) {
            this.selectUser(this.addTempUser(inputUser));
            this.setState({
              inputUser: '',
              inputUserValidation: true,
              inputUserWarningText: '',
              isNewUser: true
            });
          } else {
            this.setState({
              inputUserValidation: false,
              inputUserWarningText: validation.inputFeedback
            });
          }
        });
  }

  filterUserList(query: string) {
    let {userList} = this.state;
    let filteredList = userList.filter(function (user) {
      return user.username.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });
    this.setState({ filteredList: filteredList });
  }

  render() {
    const { isOpen } = this.state;
    let { userList, filteredList, selectedUser } = this.state;
    filteredList.sort((a, b) => {
      const nameA = a.username.toLowerCase();
      const nameB = b.username.toLowerCase();
      if (nameA < nameB)
        return -1;
      if (nameA > nameB)
        return 1
      return 0;
    });
    if (userList.findIndex((user) => user.id == selectedUser) == -1)
      selectedUser = -1;
    const { onChange, id } = this.props;
    return (
      <ButtonDropdown id={id} isOpen={isOpen} toggle={() => this.toggle()} className='btn-block' style={{ marginTop: '1.0rem' }}>
        <DropdownToggle caret outline color='dark' className='user-select-dropdown'>
          <p className='d-flex justify-content-between'>
            {
              selectedUser == -1 ? 'Select a user' : userList[userList.findIndex((user) => user.id == selectedUser)].username
            }
            <span><FontAwesomeIcon icon="caret-down" fixedWidth /></span></p>
        </DropdownToggle>
        <DropdownMenu className='user-select-dropdown-menu'>
          <div className="input-group mb-3" style={{ padding: '10px' }}>
            <input id="inputUser" name="inputUser" type="text" className={(this.state.inputUserValidation ? "form-control" : "form-control is-invalid")} placeholder="SEARCH or add New User" value={this.state.inputUser} aria-label="New Alert Only User" aria-describedby="basic-addon2" onChange={this.handleInputChange} />
            <div className={'input-group-append' + (filteredList.length == 0 ? ' d-block' : ' hide')}>
              <button type="button" className="btn btn-primary" onClick={() => this.newUser()} style={{ height: '100%' }}><i className="fas fa-plus-circle"></i> Add</button>
            </div>
            {!this.state.inputUserValidation &&
              <div className="invalid-feedback">
                {this.state.inputUserWarningText}
              </div>
            }
          </div>
          <div className="user-select-dropdown-scroll-list">
            {filteredList.map((user, idx) => {
              return (
                  <DropdownItem key={'userDrpdwn-' + idx} onClick={() => {
                    this.setState({filteredList: userList}, () => onChange(user.id, false));
                  }}>{user.username}</DropdownItem>
              );
            })}
          </div>
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}